/**
 * This is the entry point of the React application.
 * It renders the App component into the div with the id of "root" in the index.html file.
 * It also imports Bootstrap for styling.
 *
 * Author: Meng Li
 * Created on: 2024-09-30
 * Professor: Mejdi Eraslan
 * Client: Melisa Eraslan
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './assets/images/logo.png';
import './assets/styles/Variables.css';

// Dynamically set the favicon
const link = document.createElement('link');
link.rel = 'icon';
link.href = logo;
link.type = 'image/png';
document.head.appendChild(link);

// The BrowserRouter component is used to wrap the App component
// so that routing works correctly
ReactDOM.render(
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<Navigate to="/welcome" />} />
            <Route path="/*" element={<App />} />
        </Routes>
    </BrowserRouter>,
    document.getElementById('root')
);
